import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Message } from 'semantic-ui-react';

export const TaskOptionModal = ({ open, mode, singular, initialName, submitting, onSubmit, onCancel }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState(null);

    const isCreate = mode === 'add';

    useEffect(() => {
        if (open) {
            setName(initialName ?? '');
            setError(null);
        }
    }, [open, initialName]);

    const handleSubmit = async () => {
        const trimmed = name.trim();
        if (!trimmed || submitting) return;
        setError(null);
        try {
            await onSubmit(trimmed);
        } catch (err) {
            setError(err?.message || 'Something went wrong. Please try again.');
        }
    };

    return (
        <Modal
            size="tiny"
            closeIcon={!submitting}
            open={open}
            onClose={() => {
                if (submitting) return;
                onCancel();
            }}
            style={{ textAlign: 'left' }}
        >
            <Modal.Header>
                {isCreate ? 'Add' : 'Rename'} {singular}
            </Modal.Header>
            <Modal.Content>
                <Form error={!!error} loading={submitting} onSubmit={handleSubmit}>
                    <Form.Field>
                        <label>Name</label>
                        <input
                            autoFocus
                            placeholder="Name"
                            value={name}
                            onChange={e => setName(e.target.value)}
                            disabled={submitting}
                        />
                    </Form.Field>
                    <Message error content={error} />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onCancel} disabled={submitting}>
                    Cancel
                </Button>
                <Button
                    className="ui primary button"
                    onClick={handleSubmit}
                    loading={submitting}
                    disabled={submitting || !name.trim()}
                >
                    {isCreate ? 'Add' : 'Save'}
                </Button>
            </Modal.Actions>
        </Modal>
    );
};
